import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppComponent } from './app.component';
import { authInitializer } from './app.initializer';
import { CoreModule } from './core/core.module';
import { DirectivesModule } from './directives/directives.module';
import { LazyLoadModule } from './lazy-load/lazy-load.module';
import { AuthenticationService } from './services/api/authentication/authentication.service';
import { TokenService } from './services/api/authentication/token.service';
import { AzureTokenInterceptor } from './services/interceptors/azure-token.interceptor';
import { HttpHeadersInterceptor } from './services/interceptors/http-headers.interceptor';
import { HttpLoaderInterceptor } from './services/interceptors/http-loader.interceptor';
import { TemplateLoaderService } from './services/template-loader/template-loader.service';
import { SharedModule } from './shared/shared.module';
import * as store from './store';

import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import Material from '@primeng/themes/material';
import { providePrimeNG } from 'primeng/config';

@NgModule({
  declarations: [AppComponent],
  exports: [TranslateModule],
  bootstrap: [AppComponent],
  imports: [
    CoreModule,
    BrowserModule,
    LazyLoadModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    StoreModule.forRoot(store.reducers, { metaReducers: store.metaReducers }),
    EffectsModule.forRoot(store.effects),
    StoreDevtoolsModule.instrument(store.devtoolsConfig),
    DirectivesModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AzureTokenInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = authInitializer(
        inject(AuthenticationService),
        inject(Store),
        inject(TemplateLoaderService),
        inject(TokenService)
      );
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptor,
      multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Material,
      },
    }),
  ],
})
export class AppModule {}
